/**
 * description: 开发商管理
 * author: 1580043700@qq.com
 * create_date: 2023/11/10-14:31
 */

import { Form, Input, message, Modal } from 'antd'
import { useRequest, useSetState } from 'ahooks'
import {
  checkExistsByName,
  deleteBatchIds,
  insertOrUpdate,
  selectPageByQuery,
  updateById,
} from '@/services/customerServices'
import { SActionBtn, SLowcodeList, STableActions, STriggerModal } from 'shj-components'
import {tableApiFunc, trimStr} from '@/utils/data.ts'
import { useCallback, useEffect, useRef, useState } from 'react'
import config from './config.ts'
import { getAuth } from 'shj-utils'
import {authDict} from "shj-utils/dist/esm/utils";

const DeveloperlistPage = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [pageData, setPageData] = useSetState({ open: false, data: null })
  const listRef = useRef<any>()

  const { loading, runAsync } = useRequest(deleteBatchIds, { manual: true })

  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef
    reload()
  }
  const onEdit = useCallback((record?: any) => {
    setPageData({ open: true, data: record })
  }, [])
  const onDel = useCallback(({ selectedRowKeys }) => {
    const keys_ = selectedRowKeys.join(',')
    if (keys_) {
      Modal.confirm({
        title: '删除操作',
        content: '确定删除所勾选的吗？',
        onOk() {
          onDelete(selectedRowKeys)
        },
        onCancel() {},
      })
    }
  }, [])

  const onClose = success => {
    setPageData({ open: false, data: null })
    if (success) {
      reloadFn()
    }
  }

  const onDelete = (keys: any) => {
    runAsync({ data: { ids: keys } }).then(() => {
      message.success('删除成功')
      reloadFn()
    })
  }

  const extension = {
    request: {
      fetchList: tableApiFunc(selectPageByQuery, {
        data: { orderBys: [{ columnName: 'createdTime', asc: false }] },
      }),
    },
    auth: authDict,
    rowSelection: {
      selectedRowKeys,
      onChange: (selectedRowKeys: any) => {
        setSelectedRowKeys(selectedRowKeys)
      },
    },
    events: { onAdd: () => onEdit(), onDel },
    status: {
      reloadLoading: loading,
      reloadDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      actionTool(_, record: any) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>
              {/*auth="EstateButton2"*/}
              编辑
            </SActionBtn>
            <STableActions.SActionBtn
              // auth="EstateButton3"
              danger
              confirm
              loading={loading}
              title="确认删除?"
              onClick={() => onDelete([record.id])}
            >
              删除
            </STableActions.SActionBtn>
          </STableActions>
        )
      },
    },
  }
  return (
    <div>
      <SLowcodeList config={config} {...extension} ref={listRef} />
      <EditModal open={pageData.open} onClose={onClose} data={pageData.data}></EditModal>
    </div>
  )
}

/**
 * 编辑新增弹窗内容
 * @param props
 */
const EditModal = (props: { open: boolean; data?: any; onClose: (success?: boolean) => void }) => {
  const [form] = Form.useForm()

  const { runAsync } = useRequest(checkExistsByName, { manual: true })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    resetForm()
  }, [props.data])

  const resetForm = () => {
    form.resetFields()
    form.setFieldsValue(props.data)
  }

  const onFinish = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      form
        .validateFields()
        .then(values => {
          setLoading(true)
          runAsync(values.name)
            .then(() => {
              const apiFunc = props?.data?.id ? updateById : insertOrUpdate
              apiFunc({ data: { id: props?.data?.id, ...values } })
                .then(() => {
                  message.success(`${props?.data?.id ? '修改' : '新增'}成功`)
                  props?.onClose?.(true)
                  resolve()
                })
                .catch(reject)
                .finally(() => setLoading(false))
            })
            .catch(reject)
            .finally(() => setLoading(false))
        })
        .catch(reject)
    })
  }

  return (
    <STriggerModal
      title={props.data?.id ? '编辑开发商' : '新增开发商'}
      open={props.open}
      onCancel={() => props.onClose()}
      onFinish={onFinish}
      onReset={resetForm}
      loading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item label="开发商名称" name="name" rules={[{ required: true }]}>
          <Input maxLength={20} showCount onChange={(e)=>{form.setFieldValue('name', trimStr(e.target.value))}}/>
        </Form.Item>
      </Form>
    </STriggerModal>
  )
}

export default DeveloperlistPage
